import { useQuery } from '@tanstack/react-query'
import { delegationsApi } from '@/lib/api'
import { useAuthStore } from '@/store/auth'

/** The caller's active delegation (P7), if any. Only meaningful for school
 * members who are not already DPO/Dirigente — everyone else gets null
 * without a network round-trip. */
export function useActiveDelegation() {
  const { user } = useAuthStore()
  const eligible =
    !!user && (user.role === 'DOCENTE' || user.role === 'SEGRETERIA') && !!user.school_id

  const { data } = useQuery({
    queryKey: ['delegation', 'mine'],
    queryFn: delegationsApi.mine,
    enabled: eligible,
    staleTime: 60_000,
    retry: false,
  })
  return eligible ? data ?? null : null
}
